import { PeerBenchmarkDocSchema } from '@kilat/shared';

import { createRepo } from './_base.js';

/**
 * Published peer benchmarks (gap G24).
 *
 * `peerBenchmarks/{platformBrandId}:{metric}:{sizeBand}` holds ONE rounded
 * median and a participant count. It carries no tenant ids, no list of figures
 * and no maximum, so there is nothing in it to leak — which is why the read is
 * a plain document get rather than a per-tenant projection.
 *
 * A missing document is the normal state of a young network: the publisher
 * refuses to write a cohort below the anonymity floor, and deletes any stale
 * one. `null` therefore means "not enough businesses like yours yet", which the
 * card says out loud.
 */
const repo = createRepo({
  path: 'peerBenchmarks',
  schema: PeerBenchmarkDocSchema,
  name: 'peerBenchmarks',
});

export const peerBenchmarksRepo = {
  ...repo,
  /** The benchmark for one metric and size band, or null when none is published. */
  get(platformBrandId: string, metric: string, sizeBand: string) {
    return repo.get(`${platformBrandId}:${metric}:${sizeBand}`);
  },
};
